import React, { useContext, useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { check } from './services/user';
import { ApiError } from './services/error';
import { followRedirectUrl } from './helpers';
import Loader from './common/Loader';
import { CustomAppContext } from './common/CustomAppContext';

export default RedirectToMainRoute;

/**
 * This component will redirect the user to main application if authorized, before loading the route
 * @param render
 * @param routeProps
 * @returns {*}
 * @constructor
 */
function RedirectToMainRoute({ render, ...routeProps }) {
    const [authorized, setAuthorized] = useState(null);

    const { getCustomAppUrl } = useContext(CustomAppContext);
    useEffect(() => {
        (async () => {
            // check user auth, only if we didn't yet check it
            if (authorized === null) {
                try {
                    await check(false);
                    setAuthorized(true);
                } catch (err) {
                    setAuthorized(!(err instanceof ApiError));
                }
            }
        })();
    });

    if (authorized === null) {
        // shows loading
        return <Loader data-testid="app-loading" full />;
    }

    if (authorized) {
        // the user is authorized, let's redirect him further
        followRedirectUrl(getCustomAppUrl());
        return (
            <span data-testid="app-redirecting">
                Redirecting to application...
            </span>
        );
    }

    return <Route {...routeProps} render={() => render()} />;
}
